define.alias("shared/helpers/word-initials", "calendar/helpers/word-initials");